/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKdnbC%7Bborder%3A0%7D%0A._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D%0A._497WNwYbGa%7Boutline-style%3Anone%7D%0A._2zndICdnbC%7Boutline-width%3A0%7D%0A._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D%0A._3xtjKNYbGa%7Btext-decoration-line%3Anone%7D%0A._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._4kiQYAUF4f%7Bmin-height%3A40px%7D%0A._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D%0A._2xTnZxPgdg%7Bmargin-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._0rIjykPgdg%7Bmargin-block-end%3Avar(--ds-space-0%2C0)%7D%0A._0GTcwRPgdg%7Bmargin-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D%0A._0wOv4Q7zJH%7Bcursor%3Apointer%7D%0A._2hGPVj98eZ%3Afocus%3Anot(%3Afocus-visible)%7Boutline-color%3AcurrentColor%7D%0A._2i3C1kYbGa%3Afocus%3Anot(%3Afocus-visible)%7Boutline-style%3Anone%7D%0A._2kH23qT6kp%3Afocus%3Anot(%3Afocus-visible)%7Boutline-width%3Amedium%7D%0A._1zr6DcnXvL%3Afocus%7Boutline-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._1ubuxonXvL%3Afocus-visible%7Boutline-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._38a67RZPSy%3Afocus%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D%0A._34b3D2ZPSy%3Afocus-visible%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D%0A._0htemX6wH8%3Afocus%7Boutline-style%3Asolid%7D%0A._1NDpvb6wH8%3Afocus-visible%7Boutline-style%3Asolid%7D%0A._067Lcevc3e%3Afocus%7Boutline-width%3Avar(--ds-border-width-focused%2C2px)%7D%0A._2wtOC9vc3e%3Afocus-visible%7Boutline-width%3Avar(--ds-border-width-focused%2C2px)%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._3932vvYbGa%3Ahover%7Btext-decoration-line%3Anone%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._3e11vU6wH8%3Afocus-visible%7Boutline-style%3Asolid%7D._0hSAgbHZdu%3Afocus-visible%7Boutline-width%3A1px%7D%7D%0A._4ouGXIoWWg%7Bmin-width%3A24px%7D%0A._4kiQYAoWWg%7Bmin-height%3A24px%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._2zndICT6kp%7Boutline-width%3Amedium%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._2fwxA5ecOK%7Btext-align%3Aleft%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._3W2Oc8wPeg%7Bword-break%3Abreak-word%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._1UtDYzot27%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._1UtDYz98eZ%7Bcolor%3AcurrentColor%7D%0A._2nTuUY98eZ%3Avisited%7Bcolor%3AcurrentColor%7D%0A._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._0clgaM98eZ%3Ahover%7Bcolor%3AcurrentColor%7D%0A._3gzVzLo126%3Aactive%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._0CMRbk98eZ%3Aactive%7Bcolor%3AcurrentColor%7D%0A._0wOv4Qsyl5%7Bcursor%3Anot-allowed%7D%0A._1eOmH666of%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._0clgaMot27%3Ahover%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._3gzVzL66of%3Aactive%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._0CMRbkot27%3Aactive%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._3ScelF4Jdh%3Abefore%7Bwidth%3A2px%7D%0A._3dCYwDWVPG%3Abefore%7Bposition%3Aabsolute%7D%0A._4diMdqrzt2%3Abefore%7Bbackground-color%3Avar(--ds-border-selected%2C%231868db)%7D%0A._3Ku51Iogpp%3Abefore%7Bcontent%3A%22%22%7D%0A._3p3AmIPgdg%3Abefore%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._1cR5ZLPgdg%3Abefore%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._2jTvwtPgdg%3Abefore%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._1OimfuMLSV%3Abefore%7Bborder-radius%3A0%20var(--ds-radius-small%2C4px)%20var(--ds-radius-small%2C4px)%200%7D%0A._3ScelFUNDJ%3Abefore%7Bwidth%3A4px%7D%0A._3p3AmI8HPE%3Abefore%7Binset-block-end%3Avar(--ds-space-150%2C9pt)%7D%0A._1cR5ZL8HPE%3Abefore%7Binset-block-start%3Avar(--ds-space-150%2C9pt)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._2nTuUYjTy9%3Avisited%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D%0A._0clgaM866Z%3Ahover%7Bcolor%3Avar(--ds-text-accent-blue%2C%231558bc)%7D%0A._3gzVzLXsxn%3Aactive%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D%0A._0CMRbkjTy9%3Aactive%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._0clgaMjTy9%3Ahover%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._23rrnHo10F%7Btransition%3Avar(--ds-listitem-hovered%2Cbackground-color%20border-color%20color%20text-decoration-color%2050ms%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._1B4rbIo10F%3Ahover%7Btransition%3Avar(--ds-listitem-hovered%2Cbackground-color%20border-color%20color%20text-decoration-color%2050ms%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._3sFUREDdj4%3Aactive%7Btransition%3Avar(--ds-listitem-pressed%2Cbackground-color%20border-color%20color%20text-decoration-color%20.1s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._23rrnHWE38%7Btransition%3Avar(--ds-listitem-selected%2Cbackground-color%20border-color%20color%20text-decoration-color%20.1s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._4c065U2ADO%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D%0A._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D%0A._4c065U1Y8M%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D%0A._2Y7lL48HPE%7Bpadding-inline%3Avar(--ds-space-150%2C9pt)%7D%0A._4kiQYAUofl%7Bmin-height%3A2pc%7D");



























































































import { useContext } from 'react';
import { ax, ix } from '@compiled/react/runtime';
import { Inline, type InlineProps } from '@atlaskit/primitives/compiled/inline';
import type { MenuItemPrimitiveProps, RenderFunction } from '../../types';
import { SpacingContext, type SpacingMode } from './menu-context';
import { SELECTION_STYLE_CONTEXT_DO_NOT_USE } from './selection-style-context-do-not-use';
const renderTitle: RenderFunction = (Component, props) =>
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
<Component {...props} />;
const styles = {
  root: "_30huDKdnbC _2xIroY98eZ _497WNwYbGa _2zndICdnbC _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _4kiQYAUF4f _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _0hPCNLDIqT _20VacPYbGa _0wOv4Q7zJH _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1zr6DcnXvL _1ubuxonXvL _38a67RZPSy _34b3D2ZPSy _0htemX6wH8 _1NDpvb6wH8 _067Lcevc3e _2wtOC9vc3e _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3e11vU6wH8 _0hSAgbHZdu",
  beforeAfterElement: "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
  content: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2O5Vij7dHp _2fwxA5ecOK",
  truncate: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
  title: "_2sNsIgmnOE",
  wordBreak: "_3W2Oc8wPeg",
  description: "_2sNsIg7NXe _1UtDYzKGUX",
  disabledDescription: "_1UtDYzot27",
  unselected: "_0KLXru66of _1UtDYz98eZ _2nTuUY98eZ _1eOmH6o126 _0clgaM98eZ _3gzVzLo126 _0CMRbk98eZ",
  disabled: "_0wOv4Qsyl5 _0KLXru66of _1UtDYzot27 _1eOmH666of _0clgaMot27 _3gzVzL66of _0CMRbkot27",
  selectedBorder: "_3ScelF4Jdh _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmIPgdg _1cR5ZLPgdg _2jTvwtPgdg",
  selectedNotch: "_1OimfuMLSV _3ScelFUNDJ _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmI8HPE _1cR5ZL8HPE _2jTvwtPgdg",
  selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _1eOmH6sumd _0clgaM866Z _3gzVzLXsxn _0CMRbkjTy9",
  selectedOld: "_0clgaMjTy9",
  motionUnselected: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
  motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const spacingMapStyles = {
  cozy: "_4c065U2ADO _2Y7lL45zaO",
  compact: "_4c065U1Y8M _2Y7lL48HPE _4kiQYAUofl"
};
const gapMap: Record<SpacingMode, InlineProps['space']> = {
  compact: 'space.100',
  cozy: 'space.150'
};

/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */
const MenuItemPrimitive: (props: MenuItemPrimitiveProps) => JSX.Element = ({
  children,
  title,
  description,
  iconAfter,
  iconBefore,
  className: UNSAFE_externalClassName,
  shouldTitleWrap = false,
  shouldDescriptionWrap = false,
  isDisabled = false,
  isSelected = false,
  isTitleHeading = false,
  testId
}: MenuItemPrimitiveProps) => {
  const spacing = useContext(SpacingContext);
  const selectionStyle = useContext(SELECTION_STYLE_CONTEXT_DO_NOT_USE);
  const UNSAFE_className = UNSAFE_externalClassName;
  return (() => {
    return children({
      className: ax([ax([styles.root, spacingMapStyles[spacing], !isDisabled && !isSelected && styles.unselected, !isDisabled && !isSelected && styles.motionUnselected, !isDisabled && isSelected && styles.selected, !isDisabled && isSelected && styles.motionSelected, !isDisabled && isSelected && styles.selectedOld, !isDisabled && isSelected && selectionStyle === 'border' && styles.selectedBorder, !isDisabled && isSelected && selectionStyle === 'notch' && styles.selectedNotch, isDisabled && styles.disabled]), UNSAFE_className]),
      children: <Inline as="span" spread="space-between" alignBlock="center" space={gapMap[spacing]} grow="fill" testId={testId && `${testId}--container`}>
							{iconBefore && <span data-item-elem-before data-testid={testId && `${testId}--icon-before`} className={ax([styles.beforeAfterElement])}>
									{iconBefore}
								</span>}
							{title && <div className={ax([styles.content])}>
									{renderTitle(isTitleHeading ? 'h2' : 'span', {
            children: title,
            className: ax([styles.title, shouldTitleWrap ? styles.wordBreak : styles.truncate]),
            'data-item-title': true
          })}
									{description && <span data-item-description className={ax([styles.description, isDisabled && styles.disabledDescription, shouldDescriptionWrap && styles.wordBreak, !shouldDescriptionWrap && styles.truncate])}>
											{description}
										</span>}
								</div>}
							{iconAfter && <span data-item-elem-after data-testid={testId && `${testId}--icon-after`} className={ax([styles.beforeAfterElement])}>
									{iconAfter}
								</span>}
						</Inline>
    });
  })();
};
export default MenuItemPrimitive;